import React, { Fragment } from 'react';

import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

export interface StepperProps {
  children?: React.ReactNode;
  activeStep?: number;
  totalSteps?: number;
}
export default function Stepper({ children, activeStep = 1, totalSteps = 4 }: StepperProps) {
  return (
    <Fragment>
      <div className="stepper">
        {children}
        {activeStep > 0 && totalSteps > 0 && (
          <div className="stepper__container">
            {Array.from({ length: totalSteps }, (_, i) => (
              <Fragment key={i}>
                <div
                  className={`stepper__item ${i <= activeStep ? 'stepper__item--completed' : ''}`}
                >
                  {i + 1}
                </div>
                {i < totalSteps - 1 && (
                  <div className="stepper__separator">
                    {i <= activeStep && (
                      <div
                        className={`stepper__separator__progress ${
                          i <= activeStep - 1 ? 'stepper__separator__progress--completed' : ''
                        }`}
                      ></div>
                    )}
                  </div>
                )}
              </Fragment>
            ))}
          </div>
        )}
      </div>
      <div className="stepper stepper--compact">
        {children}
        {activeStep > 0 && totalSteps > 0 && (
          <div className="stepper__circular">
            <CircularProgressbarWithChildren
              strokeWidth={18}
              value={(100 / totalSteps) * (activeStep + 1)}
            >
              <div className="stepper__circular__label">
                <strong className="stepper__circular__label--active">
                  <span>{activeStep + 1}</span>
                </strong>
                <span className="stepper__circular__label--disable stepper__circular__label__separator">
                  /
                </span>

                <span className="stepper__circular__label--disable">{totalSteps}</span>
              </div>
            </CircularProgressbarWithChildren>
          </div>
        )}
      </div>
    </Fragment>
  );
}
